module.exports = __webpack_public_path__ + "static/18-1026843fe951ca12508ccc7b3e4923d9.jpg";